import * as actionType from "./constants";

const initialState = {
    getDataResponse: {},
    addDataResponse: {},
    getDataByIdResponse: {},
    updateDataResponse: {},
    deleteDataResponse: {},
    restoreDataResponse: {},
    getListForCommonFilterResponse: {},
    getDataLogsResponse: {},
    restoreDataLogResponse: {},
    deleteDataLogResponse: {},
    dataExportResponse: {},
    getAllImagesResponse: {},
    uploadImageResponse: {},
    deleteImagesResponse: {},
    updateImageResponse: {},
    entityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 40,
            offset: 0,
            search: "",
            filters: null,
            list: null,
            recommendation_assigned_true: null,
            guid_assigned: null,
            has_image: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        },
        dropDownList: {
            uniformat_level_1s: [],
            uniformat_level_2s: [],
            uniformat_level_3s: [],
            uniformat_level_4s: [],
            uniformat_level_5s: [],
            clients: [],
            trades: [],
            systems: [],
            sub_systems: [],
            regions: [],
            buildings: [],
            sites: [],
            additions: [],
            floors: [],
            asset_statuses: [],
            asset_types: [],
            manufacturers: [],
            client_standards: []
        },
        locationState: {}
    },
    selectedAsset: {},
    scrollPosition: 0,
    excelUploadResponse: null,
    masterFilterList: {},
    exportSettingsResponse: {},
    postSettingsResponse: {},
    postSettingsLoader: false,
    getWholeAssetIdsResponse: {},
    getAssetCommonDataByIdsResponse: {},
    getAssetCommonDataLoading: false,
    dropDownLoading: {},
    updateMultipleAssetsResponse: {},
    updateMultipleAssetsLoading: false,
    assetDynamicFields: null,
    recommendationAssignedCount: {},
    manufacturerCount: null,
    smartImportFields: null,
    exportGroupingDropdownExport: {},
    dropdownCount: {}
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.UPDATE_ASSET_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_ASSET_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };
        case actionType.GET_LIST_FOR_COMMON_FILTER_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LIST_FOR_COMMON_FILTER_SUCCESS:
            return {
                ...state,
                getListForCommonFilterResponse: { success: true, ...action.response }
            };
        case actionType.GET_LIST_FOR_COMMON_FILTER_FAILURE:
            return {
                ...state,
                getListForCommonFilterResponse: { success: false, ...action.error }
            };
        case actionType.GET_ASSET_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.GET_ASSET_DATA_SUCCESS:
            return {
                ...state,
                getDataResponse: { success: true, ...action.response }
            };
        case actionType.GET_ASSET_DATA_FAILURE:
            return {
                ...state,
                getDataResponse: { success: false, ...action.error }
            };
        case actionType.ADD_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.ADD_DATA_SUCCESS:
            return {
                ...state,
                addDataResponse: { success: true, ...action.response }
            };
        case actionType.ADD_DATA_FAILURE:
            return {
                ...state,
                addDataResponse: { success: false, ...action.error }
            };
        case actionType.GET_DATA_BY_ID_REQUEST:
            return {
                ...state
            };
        case actionType.GET_DATA_BY_ID_SUCCESS:
            return {
                ...state,
                getDataByIdResponse: { success: true, ...action.response }
            };
        case actionType.GET_DATA_BY_ID_FAILURE:
            return {
                ...state,
                getDataByIdResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_DATA_SUCCESS:
            return {
                ...state,
                updateDataResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_DATA_FAILURE:
            return {
                ...state,
                updateDataResponse: { success: false, ...action.error }
            };
        case actionType.DELETE_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_DATA_SUCCESS:
            return {
                ...state,
                deleteDataResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_DATA_FAILURE:
            return {
                ...state,
                deleteDataResponse: { success: false, ...action.error }
            };
        case actionType.RESTORE_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.RESTORE_DATA_SUCCESS:
            return {
                ...state,
                restoreDataResponse: { success: true, ...action.response }
            };
        case actionType.RESTORE_DATA_FAILURE:
            return {
                ...state,
                restoreDataResponse: { success: false, ...action.error }
            };
        case actionType.GET_ALL_DATA_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.GET_ALL_DATA_LOG_SUCCESS:
            return {
                ...state,
                getDataLogsResponse: { success: true, ...action.response }
            };
        case actionType.GET_ALL_DATA_LOG_FAILURE:
            return {
                ...state,
                getDataLogsResponse: { success: false, ...action.error }
            };
        case actionType.RESTORE_DATA_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.RESTORE_DATA_LOG_SUCCESS:
            return {
                ...state,
                restoreDataLogResponse: { success: true, ...action.response }
            };
        case actionType.RESTORE_DATA_LOG_FAILURE:
            return {
                ...state,
                restoreDataLogResponse: { success: false, ...action.error }
            };

        case actionType.DELETE_DATA_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_DATA_LOG_SUCCESS:
            return {
                ...state,
                deleteDataLogResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_DATA_LOG_FAILURE:
            return {
                ...state,
                deleteDataLogResponse: { success: false, ...action.error }
            };
        case actionType.GET_DATA_EXPORT_REQUEST:
            return {
                ...state
            };
        case actionType.GET_DATA_EXPORT_SUCCESS:
            return {
                ...state,
                dataExportResponse: { success: true, ...action.response }
            };
        case actionType.GET_DATA_EXPORT_FAILURE:
            return {
                ...state,
                dataExportResponse: { success: false, ...action.error }
            };
        case actionType.GET_DROPDOWN_REQUEST:
            return {
                ...state,
                dropDownLoading: { ...state.dropDownLoading, [action.entity]: true }
            };
        case actionType.GET_DROPDOWN_SUCCESS:
            return {
                ...state,
                dropDownLoading: { ...state.dropDownLoading, [action.entity]: false },
                manufacturerCount: action?.entity === "manufacturers" ? { count: action.response?.count } : state.manufacturerCount,
                dropDownList: {
                    ...state.dropDownList,
                    [action.entity]:
                        action.entity === "manufacturers"
                            ? action.response["asset_manufactures"]
                            : action.entity === "client_standards"
                              ? action.response
                              : action.entity === "project_buildings"
                                ? action.response["buildings"]
                                : action.entity === "project_sites"
                                  ? action.response["sites"]
                                  : action.response[action.entity]
                },
                dropdownCount: {
                    ...state.dropdownCount,
                    [action.entity]: action.response?.total_count
                }
            };
        case actionType.GET_DROPDOWN_FAILURE:
            return {
                ...state,
                dropDownLoading: { ...state.dropDownLoading, [action.entity]: false },
                dropDownList: {
                    ...state.dropDownList
                },
                dropdownCount: {
                    ...state.dropdownCount,
                }
            };
        case actionType.GET_ALL_IMAGES:
            return {
                ...state
            };
        case actionType.GET_ALL_IMAGES_SUCCESS:
            return {
                ...state,
                getAllImagesResponse: { success: true, ...action.response }
            };
        case actionType.GET_ALL_IMAGES_FAILURE:
            return {
                ...state,
                getAllImagesResponse: { success: false, ...action.error }
            };

        case actionType.UPLOAD_IMAGE_REQUEST:
            return {
                ...state
            };
        case actionType.UPLOAD_IMAGE_SUCCESS:
            return {
                ...state,
                uploadImageResponse: { success: true, ...action.response }
            };
        case actionType.UPLOAD_IMAGE_FAILURE:
            return {
                ...state,
                uploadImageResponse: { success: false, ...action.error }
            };

        case actionType.UPDATE_ASSET_IMAGE_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_ASSET_IMAGE_SUCCESS:
            return {
                ...state,
                updateImageResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_ASSET_IMAGE_FAILURE:
            return {
                ...state,
                updateImageResponse: { success: false, ...action.error }
            };
        case actionType.DELETE_IMAGES_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_IMAGES_SUCCESS:
            return {
                ...state,
                deleteImagesResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_IMAGES_FAILURE:
            return {
                ...state,
                deleteImagesResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_SELECTED_ASSET_SUCCESS:
            return {
                ...state,
                selectedAsset: action.response
            };
        case actionType.UPDATE_SELECTED_ASSET_FAILURE:
            return {
                ...state,
                selectedAsset: action.response
            };
        case actionType.UPDATE_ASSET_SCROLL_POSITION_SUCCESS:
            return {
                ...state,
                scrollPosition: action.response
            };
        case actionType.UPDATE_ASSET_SCROLL_POSITION_FAILURE:
            return {
                ...state,
                scrollPosition: 0
            };
        case actionType.UPLOAD_EXCEL_REQUEST:
            return {
                ...state
            };
        case actionType.UPLOAD_EXCEL_SUCCESS:
            return {
                ...state,
                excelUploadResponse: { success: true, ...action.response }
            };
        case actionType.UPLOAD_EXCEL_FAILURE:
            return {
                ...state,
                excelUploadResponse: { success: false, ...action.error }
            };
        case actionType.CLEAR_EXCEL_DATA:
            return {
                ...state,
                excelUploadResponse: null
            };

        case actionType.GET_ASSET_FILTER_REQUEST:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: { loading: true }
                }
            };
        case actionType.GET_ASSET_FILTER_SUCCESS:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: { ...action.response, loading: false }
                }
            };
        case actionType.GET_ASSET_FILTER_FAILURE:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: { loading: false }
                }
            };
        case actionType.EXPORT_FETCH_PROPERTIES_REQUEST:
            return {
                ...state
            };
        case actionType.EXPORT_FETCH_PROPERTIES_SUCCESS:
            return {
                ...state,
                exportSettingsResponse: { success: true, ...action.response }
            };
        case actionType.EXPORT_FETCH_PROPERTIES_FAILURE:
            return {
                ...state,
                exportSettingsResponse: { success: false, ...action.error }
            };
        case actionType.EXPORT_POST_PROPERTIES_REQUEST:
            return {
                ...state,
                postSettingsLoader: true
            };
        case actionType.EXPORT_POST_PROPERTIES_SUCCESS:
            return {
                ...state,
                postSettingsResponse: { success: true, ...action.response },
                postSettingsLoader: false
            };
        case actionType.EXPORT_POST_PROPERTIES_FAILURE:
            return {
                ...state,
                postSettingsResponse: { success: false, ...action.error },
                postSettingsLoader: false
            };

        case actionType.GET_WHOLE_ASSETS_IDS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_WHOLE_ASSETS_IDS_SUCCESS:
            return {
                ...state,
                getWholeAssetIdsResponse: { success: true, ...action.response }
            };
        case actionType.GET_WHOLE_ASSETS_IDS_FAILURE:
            return {
                ...state,
                getWholeAssetIdsResponse: { success: false, ...action.error }
            };

        case actionType.GET_ASSET_COMMON_DATA_BY_IDS_REQUEST:
            return {
                ...state,
                getAssetCommonDataLoading: true
            };
        case actionType.GET_ASSET_COMMON_DATA_BY_IDS_SUCCESS:
            return {
                ...state,
                getAssetCommonDataByIdsResponse: { success: true, ...action.response },
                getAssetCommonDataLoading: false
            };
        case actionType.GET_ASSET_COMMON_DATA_BY_IDS_FAILURE:
            return {
                ...state,
                getAssetCommonDataByIdsResponse: { success: false, ...action.error },
                getAssetCommonDataLoading: false
            };
        case actionType.RESET_ASSET_COMMON_DATA:
            return {
                ...state,
                getAssetCommonDataByIdsResponse: {}
            };

        case actionType.UPDATE_MULTI_ASSET_REQUEST:
            return {
                ...state,
                updateMultipleAssetsLoading: true
            };
        case actionType.UPDATE_MULTI_ASSET_SUCCESS:
            return {
                ...state,
                updateMultipleAssetsResponse: { success: true, ...action.response },
                updateMultipleAssetsLoading: false
            };
        case actionType.UPDATE_MULTI_ASSET_FAILURE:
            return {
                ...state,
                updateMultipleAssetsResponse: { success: false, ...action.error },
                updateMultipleAssetsLoading: false
            };

        case actionType.GET_ASSET_DYNAMIC_FIELDS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_ASSET_DYNAMIC_FIELDS_SUCCESS:
            return {
                ...state,
                assetDynamicFields: { success: true, ...action.response }
            };
        case actionType.GET_ASSET_DYNAMIC_FIELDS_FAILURE:
            return {
                ...state,
                assetDynamicFields: { success: false, ...action.error }
            };
        case actionType.GET_RECOMMENDATION_ASSIGNED_COUNT_REQUEST:
            return {
                ...state,
                recommendationAssignedCount: { loading: true }
            };
        case actionType.GET_RECOMMENDATION_ASSIGNED_COUNT_SUCCESS:
            return {
                ...state,
                recommendationAssignedCount: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_RECOMMENDATION_ASSIGNED_COUNT_FAILURE:
            return {
                ...state,
                recommendationAssignedCount: { loading: false, success: false }
            };
        case actionType.GET_FAVORITES_REQUEST:
            return {
                ...state,
                favoriteFilters: { loading: true }
            };
        case actionType.GET_FAVORITES_SUCCESS:
            return {
                ...state,
                favoriteFilters: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_FAVORITES_FAILURE:
            return {
                ...state,
                favoriteFilters: { loading: false, success: false }
            };
        case actionType.GET_SMART_IMPORT_FIELDS_REQUEST:
            return {
                ...state,
                smartImportFields: { loading: true }
            };
        case actionType.GET_SMART_IMPORT_FIELDS_SUCCESS:
            return {
                ...state,
                smartImportFields: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_SMART_IMPORT_FIELDS_FAILURE:
            return {
                ...state,
                smartImportFields: { loading: false, success: false }
            };

        case actionType.GET_EXPORT_GROUPING_DROPDOWN_REQUEST:
            return {
                ...state,
                exportGroupingDropdownExport: { loading: true }
            };
        case actionType.GET_EXPORT_GROUPING_DROPDOWN_SUCCESS:
            return {
                ...state,
                exportGroupingDropdownExport: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_EXPORT_GROUPING_DROPDOWN_FAILURE:
            return {
                ...state,
                exportGroupingDropdownExport: { loading: false, success: false }
            };

        default:
            return state;
    }
};

export default reducers;
